import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc5e1ee5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "curriculum",
  class: "pt-30"
}
const _hoisted_2 = { class: "tp-course-details-2-main-title" }
const _hoisted_3 = { class: "tp-course-details-2-faq" }
const _hoisted_4 = {
  class: "accordion",
  id: "_accordionPanelsStayOpenExample"
}
const _hoisted_5 = ["id"]
const _hoisted_6 = ["data-bs-target", "aria-expanded", "aria-controls"]
const _hoisted_7 = { class: "span" }
const _hoisted_8 = { class: "lesson" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "accordion-btn" }, null, -1 /* HOISTED */))
const _hoisted_10 = ["id", "aria-labelledby"]
const _hoisted_11 = { class: "accordion-body" }
const _hoisted_12 = { class: "tp-course-details-2-faq-item" }
const _hoisted_13 = { class: "d-flex justify-content-between" }
const _hoisted_14 = { class: "left" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-clipboard-list-check mr-10 text-secondary" }, null, -1 /* HOISTED */))
const _hoisted_16 = { class: "right" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 2,
  class: "far fa-lock-alt"
}
const _hoisted_20 = { class: "left" }
const _hoisted_21 = {
  key: 0,
  class: "far fa-play-circle mr-10 text-secondary"
}
const _hoisted_22 = {
  key: 1,
  class: "far fa-headphones mr-10 text-secondary"
}
const _hoisted_23 = {
  key: 2,
  class: "far fa-file-pdf mr-10 text-secondary"
}
const _hoisted_24 = {
  key: 3,
  class: "far fa-book mr-10 text-secondary"
}
const _hoisted_25 = { class: "right" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 1,
  class: "far fa-lock-alt"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clearfix" }, null, -1 /* HOISTED */))
const _hoisted_29 = {
  key: 0,
  class: "alert alert-info mt-3",
  style: {"padding":"5px 10px"}
}
const _hoisted_30 = { class: "mb-0 font-s-13 text-dark" }
const _hoisted_31 = {
  key: 1,
  class: "alert alert-warning mt-3",
  style: {"padding":"5px 10px"}
}
const _hoisted_32 = { class: "mb-1" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Open Your Submissions", -1 /* HOISTED */))
const _hoisted_34 = {
  key: 0,
  class: "text-center mt-3"
}
const _hoisted_35 = { class: "mt-3" }
const _hoisted_36 = { class: "text-secondary" }
const _hoisted_37 = {
  key: 0,
  class: "text-success"
}
const _hoisted_38 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_39 = { class: "text-dark" }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = { class: "question-content" }
const _hoisted_43 = { class: "list-group" }
const _hoisted_44 = ["data-uid"]
const _hoisted_45 = ["onUpdate:modelValue", "id", "value"]
const _hoisted_46 = ["onUpdate:modelValue", "id", "value"]
const _hoisted_47 = ["for"]
const _hoisted_48 = {
  key: 0,
  class: "badge text-bg-secondary mr-1"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-minus-circle" }, null, -1 /* HOISTED */))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = {
  key: 1,
  class: "badge text-bg-success mr-1"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-check" }, null, -1 /* HOISTED */))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = {
  key: 2,
  class: "badge text-bg-danger mr-1"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-times" }, null, -1 /* HOISTED */))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = { class: "form-check-label stretched-link" }
const _hoisted_58 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-info-circle mr-1" }, null, -1 /* HOISTED */))
const _hoisted_60 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_61 = ["onUpdate:modelValue"]
const _hoisted_62 = {
  key: 0,
  class: "valid-feedback d-block"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-check-circle mr-1" }, null, -1 /* HOISTED */))
const _hoisted_64 = {
  key: 1,
  class: "invalid-feedback d-block"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-times-circle mr-1" }, null, -1 /* HOISTED */))
const _hoisted_66 = {
  key: 2,
  class: "invalid-feedback d-block"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-info-circle mr-1" }, null, -1 /* HOISTED */))
const _hoisted_68 = { class: "d-flex align-items-center mt-4" }
const _hoisted_69 = { class: "text-secondary" }
const _hoisted_70 = { class: "ms-auto" }
const _hoisted_71 = ["onClick", "disabled"]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-check-circle" }, null, -1 /* HOISTED */))
const _hoisted_73 = ["onClick", "disabled"]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-arrow-right ml-1" }, null, -1 /* HOISTED */))
const _hoisted_75 = ["disabled"]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-arrow-right ml-1" }, null, -1 /* HOISTED */))
const _hoisted_77 = ["onClick", "disabled"]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-arrow-right ml-1" }, null, -1 /* HOISTED */))
const _hoisted_79 = ["disabled"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-arrow-right ml-1" }, null, -1 /* HOISTED */))
const _hoisted_81 = {
  class: "modal fade",
  id: "lessonViewModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "lessonViewModalLabel",
  "aria-hidden": "true"
}
const _hoisted_82 = { class: "modal-content" }
const _hoisted_83 = { class: "modal-header" }
const _hoisted_84 = {
  class: "modal-title fs-5",
  id: "lessonViewModalLabel"
}
const _hoisted_85 = { class: "ms-auto" }
const _hoisted_86 = {
  key: 0,
  class: "far fa-expand"
}
const _hoisted_87 = {
  key: 1,
  class: "far fa-compress"
}
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */))
const _hoisted_89 = { class: "modal-body" }
const _hoisted_90 = {
  key: 0,
  class: "row"
}
const _hoisted_91 = ["src"]
const _hoisted_92 = {
  key: 1,
  class: "alert alert-warning"
}
const _hoisted_93 = {
  key: 0,
  controls: "",
  controlsList: "nodownload",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_94 = ["src"]
const _hoisted_95 = {
  key: 1,
  class: "google-drive-iframe"
}
const _hoisted_96 = ["src"]
const _hoisted_97 = {
  key: 2,
  class: "alert alert-warning"
}
const _hoisted_98 = {
  key: 2,
  class: "col-lg-4"
}
const _hoisted_99 = {
  key: 0,
  class: "card mb-3"
}
const _hoisted_100 = { class: "card-header" }
const _hoisted_101 = { class: "list-group list-group-flush" }
const _hoisted_102 = { class: "list-group-item" }
const _hoisted_103 = {
  key: 0,
  controls: "",
  controlsList: "nodownload",
  style: {"width":"100%"}
}
const _hoisted_104 = ["src"]
const _hoisted_105 = {
  key: 1,
  class: "card"
}
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, " Text Content ", -1 /* HOISTED */))
const _hoisted_107 = ["innerHTML"]
const _hoisted_108 = {
  key: 1,
  class: "row"
}
const _hoisted_109 = { class: "mb-3" }
const _hoisted_110 = ["src"]
const _hoisted_111 = {
  key: 1,
  class: "google-drive-iframe"
}
const _hoisted_112 = ["src"]
const _hoisted_113 = {
  key: 2,
  class: "alert alert-warning"
}
const _hoisted_114 = {
  key: 0,
  controls: "",
  controlsList: "nodownload",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_115 = ["src"]
const _hoisted_116 = {
  key: 1,
  class: "google-drive-iframe"
}
const _hoisted_117 = ["src"]
const _hoisted_118 = {
  key: 2,
  class: "alert alert-warning"
}
const _hoisted_119 = {
  key: 0,
  class: "col-lg-4"
}
const _hoisted_120 = {
  key: 0,
  class: "card mb-3"
}
const _hoisted_121 = { class: "card-header" }
const _hoisted_122 = { class: "list-group list-group-flush" }
const _hoisted_123 = { class: "list-group-item" }
const _hoisted_124 = {
  key: 0,
  controls: "",
  controlsList: "nodownload",
  style: {"width":"100%"}
}
const _hoisted_125 = ["src"]
const _hoisted_126 = {
  key: 1,
  class: "card"
}
const _hoisted_127 = { class: "card-header" }
const _hoisted_128 = ["innerHTML"]
const _hoisted_129 = {
  key: 0,
  controls: "",
  controlsList: "nodownload",
  style: {"width":"100%"}
}
const _hoisted_130 = ["src"]
const _hoisted_131 = {
  key: 1,
  class: "alert alert-warning"
}
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "PDFViewer" }, null, -1 /* HOISTED */))
const _hoisted_133 = [
  _hoisted_132
]
const _hoisted_134 = {
  key: 1,
  class: "google-drive-iframe"
}
const _hoisted_135 = ["src"]
const _hoisted_136 = {
  key: 2,
  class: "alert alert-warning"
}
const _hoisted_137 = {
  key: 3,
  class: "row mt-3"
}
const _hoisted_138 = {
  key: 0,
  class: "col-lg-4"
}
const _hoisted_139 = { class: "card" }
const _hoisted_140 = { class: "card-header" }
const _hoisted_141 = { class: "list-group list-group-flush" }
const _hoisted_142 = { class: "list-group-item" }
const _hoisted_143 = {
  key: 0,
  controls: "",
  controlsList: "nodownload",
  style: {"width":"100%"}
}
const _hoisted_144 = ["src"]
const _hoisted_145 = {
  key: 1,
  class: "col-lg-8"
}
const _hoisted_146 = {
  key: 0,
  class: "card"
}
const _hoisted_147 = { class: "card-header" }
const _hoisted_148 = ["innerHTML"]
const _hoisted_149 = {
  class: "pdf-viewer",
  style: {"direction":"ltr"}
}
const _hoisted_150 = ["src"]
const _hoisted_151 = {
  key: 0,
  class: "card mt-3"
}
const _hoisted_152 = { class: "card-header" }
const _hoisted_153 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_CheckMark = _resolveComponent("CheckMark")
  const _component_FailMark = _resolveComponent("FailMark")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", _hoisted_2, _toDisplayString($setup.lms_website.__('Course Content')), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.chapters.list, (chapter, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: chapter.uid,
              class: "accordion-item"
            }, [
              _createElementVNode("h2", {
                class: "accordion-header",
                id: `panelsStayOpen-heading-${chapter.uid}`
              }, [
                _createElementVNode("button", {
                  class: _normalizeClass(["accordion-button d-flex justify-content-between", (index === 0)?'':'collapsed']),
                  type: "button",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": `#panelsStayOpen-collapse-${chapter.uid}`,
                  "aria-expanded": index === 0,
                  "aria-controls": `panelsStayOpen-collapse-${chapter.uid}`
                }, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString($setup.lms_website.__(chapter.title)), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(chapter.lessons?.length) + " " + _toDisplayString($setup.lms_website.__('Lessons')), 1 /* TEXT */),
                  _hoisted_9
                ], 10 /* CLASS, PROPS */, _hoisted_6)
              ], 8 /* PROPS */, _hoisted_5),
              _createElementVNode("div", {
                id: `panelsStayOpen-collapse-${chapter.uid}`,
                class: _normalizeClass(["accordion-collapse collapse", (index === 0)?'show':'']),
                "aria-labelledby": `panelsStayOpen-heading-${chapter.uid}`
              }, [
                _createElementVNode("div", _hoisted_11, [
                  (chapter.lessons?.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(chapter.lessons, (lesson) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            (lesson.quiz_id)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("span", null, [
                                      _hoisted_15,
                                      _createElementVNode("i", null, _toDisplayString($setup.lms_website.__('Quiz')) + ":", 1 /* TEXT */),
                                      _createTextVNode(" " + _toDisplayString($setup.lms_website.__(lesson.title)), 1 /* TEXT */)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("span", null, [
                                      ($props.courseEnrolled && !$data.quiz.is_start)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            onClick: $event => ($options.startQuiz(lesson.quiz_id)),
                                            class: "pointer-event green"
                                          }, _toDisplayString($setup.lms_website.__('Start')), 9 /* TEXT, PROPS */, _hoisted_17))
                                        : _createCommentVNode("v-if", true),
                                      ($props.courseEnrolled && $data.quiz.is_start)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 1,
                                            onClick: $event => ($options.cancelQuiz(lesson.quiz_id)),
                                            class: "pointer-event red"
                                          }, _toDisplayString($setup.lms_website.__('Cancel')), 9 /* TEXT, PROPS */, _hoisted_18))
                                        : _createCommentVNode("v-if", true),
                                      (!$props.courseEnrolled)
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                                        : _createCommentVNode("v-if", true)
                                    ])
                                  ])
                                ], 64 /* STABLE_FRAGMENT */))
                              : _createCommentVNode("v-if", true),
                            (!lesson.quiz_id)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("span", null, [
                                      (lesson.custom_lesson_type==='Video' || lesson.custom_lesson_type==='Multiple Videos')
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_21))
                                        : _createCommentVNode("v-if", true),
                                      (lesson.custom_lesson_type==='Audio')
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_22))
                                        : _createCommentVNode("v-if", true),
                                      (lesson.custom_lesson_type==='PDF')
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_23))
                                        : _createCommentVNode("v-if", true),
                                      (lesson.custom_lesson_type==='PDF Link')
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_24))
                                        : _createCommentVNode("v-if", true),
                                      _createElementVNode("i", null, _toDisplayString(lesson.custom_lesson_type) + ":", 1 /* TEXT */),
                                      _createTextVNode(" " + _toDisplayString(lesson.title), 1 /* TEXT */)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("span", null, [
                                      (lesson.include_in_preview ||  $props.courseEnrolled)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            onClick: $event => ($options.openLessonModal(lesson)),
                                            class: "pointer-event"
                                          }, _toDisplayString($setup.lms_website.__('Preview')), 9 /* TEXT, PROPS */, _hoisted_26))
                                        : _createCommentVNode("v-if", true),
                                      (!lesson.include_in_preview && !$props.courseEnrolled)
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_27))
                                        : _createCommentVNode("v-if", true)
                                    ])
                                  ])
                                ], 64 /* STABLE_FRAGMENT */))
                              : _createCommentVNode("v-if", true)
                          ]),
                          (lesson.quiz_id && $data.quiz.is_start && $data.quiz.active_quiz===lesson.quiz_id)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_28,
                                _createElementVNode("div", {
                                  class: _normalizeClass(["course-quiz-content", {'form-loading':($data.quiz.loading || $data.quiz.submit_loading)}])
                                }, [
                                  _createElementVNode("h5", null, _toDisplayString($data.quiz.data?.title), 1 /* TEXT */),
                                  ($options.checkQuizMaxAttempts)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                        _createElementVNode("p", _hoisted_30, _toDisplayString($setup.lms_website.__('You will have to get {0}% correct answers in order to pass the quiz.', [$data.quiz.data?.passing_percentage])), 1 /* TEXT */)
                                      ]))
                                    : _createCommentVNode("v-if", true),
                                  (!$options.checkQuizMaxAttempts)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                        _createElementVNode("p", _hoisted_32, _toDisplayString($setup.lms_website.__('You have reached the maximum number of attempts allowed for this quiz')), 1 /* TEXT */),
                                        _createVNode(_component_router_link, { to: {name:'profile.my_quiz'} }, {
                                          default: _withCtx(() => [
                                            _hoisted_33
                                          ]),
                                          _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["to"])
                                      ]))
                                    : _createCommentVNode("v-if", true),
                                  ($options.checkQuizMaxAttempts)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        ($data.quiz.is_submitted)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                              ($data.quiz.result?.pass)
                                                ? (_openBlock(), _createBlock(_component_CheckMark, { key: 0 }))
                                                : _createCommentVNode("v-if", true),
                                              (!$data.quiz.result?.pass)
                                                ? (_openBlock(), _createBlock(_component_FailMark, { key: 1 }))
                                                : _createCommentVNode("v-if", true),
                                              _createElementVNode("h3", _hoisted_35, [
                                                _createElementVNode("span", _hoisted_36, _toDisplayString($setup.lms_website.__('You got {0}%', [$data.quiz.result?.percentage])) + " - ", 1 /* TEXT */),
                                                ($data.quiz.result?.pass)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString($setup.lms_website.__('Passed')), 1 /* TEXT */))
                                                  : _createCommentVNode("v-if", true),
                                                (!$data.quiz.result?.pass)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString($setup.lms_website.__('Failed')), 1 /* TEXT */))
                                                  : _createCommentVNode("v-if", true)
                                              ]),
                                              _createElementVNode("p", _hoisted_39, _toDisplayString($setup.lms_website.__('Your score is {0}/{1}.', [$data.quiz.result?.score, $data.quiz.result?.score_out_of])), 1 /* TEXT */)
                                            ]))
                                          : _createCommentVNode("v-if", true),
                                        (!$data.quiz.is_submitted)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.quizQuestions, (question) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                  _createElementVNode("fieldset", null, [
                                                    _createElementVNode("div", {
                                                      class: "question-title",
                                                      innerHTML: question.question
                                                    }, null, 8 /* PROPS */, _hoisted_41),
                                                    _createElementVNode("div", _hoisted_42, [
                                                      (question.type==='Choices')
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _createElementVNode("ul", _hoisted_43, [
                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((question.answers), (answer) => {
                                                                return (_openBlock(), _createElementBlock(_Fragment, {
                                                                  key: answer.uid
                                                                }, [
                                                                  (answer.answer)
                                                                    ? (_openBlock(), _createElementBlock("li", {
                                                                        key: 0,
                                                                        class: "list-group-item d-flex align-items-center",
                                                                        "data-uid": answer.uid
                                                                      }, [
                                                                        (!question.is_checked)
                                                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                              (!question.multiple)
                                                                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                                                    key: 0,
                                                                                    class: "form-check-input form-check-input-lg mr-2",
                                                                                    type: "radio",
                                                                                    "onUpdate:modelValue": $event => (($data.quiz.answers[question.name]) = $event),
                                                                                    id: `${question.name}-option_${answer.uid}`,
                                                                                    value: answer.answer
                                                                                  }, null, 8 /* PROPS */, _hoisted_45)), [
                                                                                    [_vModelRadio, $data.quiz.answers[question.name]]
                                                                                  ])
                                                                                : _createCommentVNode("v-if", true),
                                                                              (question.multiple)
                                                                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                                                    key: 1,
                                                                                    class: "form-check-input form-check-input-lg mr-2",
                                                                                    type: "checkbox",
                                                                                    "onUpdate:modelValue": $event => (($data.quiz.answers[question.name]) = $event),
                                                                                    id: `${question.name}-option_${answer.uid}`,
                                                                                    value: answer.answer
                                                                                  }, null, 8 /* PROPS */, _hoisted_46)), [
                                                                                    [_vModelCheckbox, $data.quiz.answers[question.name]]
                                                                                  ])
                                                                                : _createCommentVNode("v-if", true),
                                                                              _createElementVNode("label", {
                                                                                class: "form-check-label stretched-link",
                                                                                for: `${question.name}-option_${answer.uid}`
                                                                              }, _toDisplayString(answer.answer), 9 /* TEXT, PROPS */, _hoisted_47)
                                                                            ], 64 /* STABLE_FRAGMENT */))
                                                                          : _createCommentVNode("v-if", true),
                                                                        (question.is_checked)
                                                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                              (!answer.is_answered && !answer.is_correct)
                                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_48, _hoisted_50))
                                                                                : _createCommentVNode("v-if", true),
                                                                              ((answer.is_answered && answer.is_correct) || answer.is_correct)
                                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_51, _hoisted_53))
                                                                                : _createCommentVNode("v-if", true),
                                                                              (answer.is_answered && !answer.is_correct)
                                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_54, _hoisted_56))
                                                                                : _createCommentVNode("v-if", true),
                                                                              _createElementVNode("label", _hoisted_57, _toDisplayString(answer.answer), 1 /* TEXT */)
                                                                            ], 64 /* STABLE_FRAGMENT */))
                                                                          : _createCommentVNode("v-if", true)
                                                                      ], 8 /* PROPS */, _hoisted_44))
                                                                    : _createCommentVNode("v-if", true)
                                                                ], 64 /* STABLE_FRAGMENT */))
                                                              }), 128 /* KEYED_FRAGMENT */))
                                                            ]),
                                                            (question.validate_error)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                                                  _hoisted_59,
                                                                  _createTextVNode(" " + _toDisplayString(question.validate_error), 1 /* TEXT */)
                                                                ]))
                                                              : _createCommentVNode("v-if", true)
                                                          ], 64 /* STABLE_FRAGMENT */))
                                                        : _createCommentVNode("v-if", true),
                                                      (question.type==='User Input')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                                            _withDirectives(_createElementVNode("textarea", {
                                                              class: _normalizeClass(["form-control", {'is-invalid':(question.correct_error),'is-valid':(question.correct_success)}]),
                                                              "onUpdate:modelValue": $event => (($data.quiz.answers[question.name]) = $event),
                                                              style: {"height":"100px","resize":"none"},
                                                              placeholder: "Your Answer"
                                                            }, null, 10 /* CLASS, PROPS */, _hoisted_61), [
                                                              [_vModelText, $data.quiz.answers[question.name]]
                                                            ]),
                                                            (question.correct_success)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                                                  _hoisted_63,
                                                                  _createTextVNode(" " + _toDisplayString(question.correct_success), 1 /* TEXT */)
                                                                ]))
                                                              : _createCommentVNode("v-if", true),
                                                            (question.correct_error)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                                                  _hoisted_65,
                                                                  _createTextVNode(" " + _toDisplayString(question.correct_error), 1 /* TEXT */)
                                                                ]))
                                                              : _createCommentVNode("v-if", true),
                                                            (question.validate_error)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                                                  _hoisted_67,
                                                                  _createTextVNode(" " + _toDisplayString(question.validate_error), 1 /* TEXT */)
                                                                ]))
                                                              : _createCommentVNode("v-if", true)
                                                          ]))
                                                        : _createCommentVNode("v-if", true)
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_68, [
                                                    _createElementVNode("b", _hoisted_69, "Question " + _toDisplayString($data.quiz.pagination.currentPage) + " / " + _toDisplayString($data.quiz.data?.custom_number_of_questions), 1 /* TEXT */),
                                                    _createElementVNode("div", _hoisted_70, [
                                                      ($data.quiz.data?.show_answers)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            (!question.is_checked)
                                                              ? (_openBlock(), _createElementBlock("button", {
                                                                  key: 0,
                                                                  type: "button",
                                                                  class: "btn btn-sm btn-primary",
                                                                  onClick: $event => ($options.quiz_check_answer(question)),
                                                                  disabled: !$data.quiz.answers[question.name] || !$data.quiz.answers[question.name]?.length
                                                                }, [
                                                                  _hoisted_72,
                                                                  _createTextVNode(" Check")
                                                                ], 8 /* PROPS */, _hoisted_71))
                                                              : _createCommentVNode("v-if", true),
                                                            (question.is_checked && ($data.quiz.pagination.currentPage < $data.quiz.data?.custom_number_of_questions))
                                                              ? (_openBlock(), _createElementBlock("button", {
                                                                  key: 1,
                                                                  type: "button",
                                                                  class: "btn btn-sm btn-secondary",
                                                                  onClick: $event => ($options.next_question(question)),
                                                                  disabled: !$data.quiz.answers[question.name]
                                                                }, [
                                                                  _createTextVNode("Next Question "),
                                                                  _hoisted_74
                                                                ], 8 /* PROPS */, _hoisted_73))
                                                              : _createCommentVNode("v-if", true),
                                                            (question.is_checked && ($data.quiz.pagination.currentPage === $data.quiz.data?.custom_number_of_questions))
                                                              ? (_openBlock(), _createElementBlock("button", {
                                                                  key: 2,
                                                                  type: "button",
                                                                  class: "btn btn-sm btn-primary",
                                                                  onClick: _cache[0] || (_cache[0] = $event => ($options.submit_answers())),
                                                                  disabled: !$data.quiz.answers[question.name]
                                                                }, [
                                                                  _createTextVNode("Submit Answers "),
                                                                  _hoisted_76
                                                                ], 8 /* PROPS */, _hoisted_75))
                                                              : _createCommentVNode("v-if", true)
                                                          ], 64 /* STABLE_FRAGMENT */))
                                                        : _createCommentVNode("v-if", true),
                                                      (!$data.quiz.data?.show_answers)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                            (($data.quiz.pagination.currentPage < $data.quiz.data?.custom_number_of_questions))
                                                              ? (_openBlock(), _createElementBlock("button", {
                                                                  key: 0,
                                                                  type: "button",
                                                                  class: "btn btn-sm btn-secondary",
                                                                  onClick: $event => ($options.next_question(question)),
                                                                  disabled: !$data.quiz.answers[question.name] || !$data.quiz.answers[question.name]?.length
                                                                }, [
                                                                  _createTextVNode("Next Question "),
                                                                  _hoisted_78
                                                                ], 8 /* PROPS */, _hoisted_77))
                                                              : _createCommentVNode("v-if", true),
                                                            (($data.quiz.pagination.currentPage === $data.quiz.data?.custom_number_of_questions))
                                                              ? (_openBlock(), _createElementBlock("button", {
                                                                  key: 1,
                                                                  type: "button",
                                                                  class: "btn btn-sm btn-primary",
                                                                  onClick: _cache[1] || (_cache[1] = $event => ($options.submit_answers())),
                                                                  disabled: !$data.quiz.answers[question.name]
                                                                }, [
                                                                  _createTextVNode("Submit Answers "),
                                                                  _hoisted_80
                                                                ], 8 /* PROPS */, _hoisted_79))
                                                              : _createCommentVNode("v-if", true)
                                                          ], 64 /* STABLE_FRAGMENT */))
                                                        : _createCommentVNode("v-if", true)
                                                    ])
                                                  ])
                                                ], 64 /* STABLE_FRAGMENT */))
                                              }), 256 /* UNKEYED_FRAGMENT */))
                                            ]))
                                          : _createCommentVNode("v-if", true)
                                      ], 64 /* STABLE_FRAGMENT */))
                                    : _createCommentVNode("v-if", true)
                                ], 2 /* CLASS */)
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true)
                        ]))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ])
              ], 10 /* CLASS, PROPS */, _hoisted_10)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_81, [
      _createElementVNode("div", {
        class: _normalizeClass(["modal-dialog modal-dialog-scrollable", {'modal-fullscreen':($data.lessonModal.full_screen),'modal-xl':(!$data.lessonModal.full_screen)}])
      }, [
        _createElementVNode("div", _hoisted_82, [
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("h1", _hoisted_84, _toDisplayString($data.lessonModal.lesson?.title), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-full-screen",
                onClick: _cache[2] || (_cache[2] = $event => ($data.lessonModal.full_screen=!$data.lessonModal.full_screen))
              }, [
                (!$data.lessonModal.full_screen)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_86))
                  : _createCommentVNode("v-if", true),
                ($data.lessonModal.full_screen)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_87))
                  : _createCommentVNode("v-if", true)
              ]),
              _hoisted_88
            ])
          ]),
          _createElementVNode("div", _hoisted_89, [
            _createCommentVNode("Video"),
            ($data.lessonModal.lesson?.custom_lesson_type==='Video')
              ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                  _createElementVNode("div", {
                    class: _normalizeClass(($data.lessonModal.lesson?.pdf_audio_list?.length || $data.lessonModal.lesson?.custom_text_content?.length)?'col-lg-8':'col-lg-12')
                  }, [
                    ($data.lessonModal.lesson?.custom_video_type==='YouTube Link')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          ($data.lessonModal.lesson?.custom_youtube_link)
                            ? (_openBlock(), _createElementBlock("iframe", {
                                key: 0,
                                class: "youtube-iframe",
                                style: {"width":"100%","border":"0","border-radius":"10px"},
                                src: `https://www.youtube.com/embed/${$options.getYouTubeVideoId($data.lessonModal.lesson?.custom_youtube_link)}`,
                                allowFullscreen: "",
                                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              }, null, 8 /* PROPS */, _hoisted_91))
                            : _createCommentVNode("v-if", true),
                          (!$data.lessonModal.lesson?.custom_youtube_link)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_92, "Video url not found"))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    ($data.lessonModal.lesson?.custom_video_type==='Attach File')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (!$options.isGoogleDriveLink($data.lessonModal.lesson?.custom_video_link))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                ($data.lessonModal.lesson?.custom_video_link)
                                  ? (_openBlock(), _createElementBlock("video", _hoisted_93, [
                                      _createElementVNode("source", {
                                        src: $data.lessonModal.lesson?.custom_video_link,
                                        type: "audio/ogg"
                                      }, null, 8 /* PROPS */, _hoisted_94),
                                      _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Your browser does not support the video tag.')), 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true),
                          ($options.isGoogleDriveLink($data.lessonModal.lesson?.custom_video_link))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                ($data.lessonModal.lesson?.custom_video_link)
                                  ? (_openBlock(), _createElementBlock("iframe", {
                                      key: 0,
                                      class: "custom-iframe",
                                      src: $options.googleDriveLinkPreview($data.lessonModal.lesson?.custom_video_link),
                                      style: {"width":"100%","border":"0","border-radius":"10px"}
                                    }, null, 8 /* PROPS */, _hoisted_96))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            : _createCommentVNode("v-if", true),
                          (!$data.lessonModal.lesson?.custom_video_link)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_97, _toDisplayString($setup.lms_website.__('Video file url not found')), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    ($data.lessonModal.lesson?.pdf_audio_list?.length || $data.lessonModal.lesson?.custom_text_content?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                          ($data.lessonModal.lesson?.pdf_audio_list?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                _createElementVNode("div", _hoisted_100, _toDisplayString($setup.lms_website.__('Audio List')), 1 /* TEXT */),
                                _createElementVNode("ul", _hoisted_101, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.lessonModal.lesson?.pdf_audio_list, (audio) => {
                                    return (_openBlock(), _createElementBlock("li", _hoisted_102, [
                                      _createTextVNode(_toDisplayString(audio.title) + " ", 1 /* TEXT */),
                                      (audio.audio_file)
                                        ? (_openBlock(), _createElementBlock("audio", _hoisted_103, [
                                            _createElementVNode("source", {
                                              src: audio.audio_file,
                                              type: "audio/ogg"
                                            }, null, 8 /* PROPS */, _hoisted_104),
                                            _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Your browser does not support the audio tag.')), 1 /* TEXT */)
                                          ]))
                                        : _createCommentVNode("v-if", true)
                                    ]))
                                  }), 256 /* UNKEYED_FRAGMENT */))
                                ])
                              ]))
                            : _createCommentVNode("v-if", true),
                          ($data.lessonModal.lesson?.custom_text_content?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                _hoisted_106,
                                _createElementVNode("div", {
                                  class: "card-body",
                                  innerHTML: $data.lessonModal.lesson?.custom_text_content
                                }, null, 8 /* PROPS */, _hoisted_107)
                              ]))
                            : _createCommentVNode("v-if", true)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */)
                ]))
              : _createCommentVNode("v-if", true),
            ($data.lessonModal.lesson?.custom_lesson_type==='Multiple Videos')
              ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                  _createElementVNode("div", {
                    class: _normalizeClass(($data.lessonModal.lesson?.pdf_audio_list?.length || $data.lessonModal.lesson?.custom_text_content?.length)?'col-lg-8':'col-lg-12')
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.lessonModal.lesson?.videos_list, (video) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_109, [
                        (video.link_type==='URL')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (!$options.isGoogleDriveLink(video.attach_video))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (video.video_url)
                                      ? (_openBlock(), _createElementBlock("iframe", {
                                          key: 0,
                                          class: "youtube-iframe",
                                          style: {"width":"100%","border":"0","border-radius":"10px"},
                                          src: `https://www.youtube.com/embed/${$options.getYouTubeVideoId(video.video_url)}`,
                                          allowFullscreen: "",
                                          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        }, null, 8 /* PROPS */, _hoisted_110))
                                      : _createCommentVNode("v-if", true)
                                  ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true),
                              ($options.isGoogleDriveLink(video.attach_video))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                                    (video.attach_video)
                                      ? (_openBlock(), _createElementBlock("iframe", {
                                          key: 0,
                                          class: "custom-iframe",
                                          src: $options.googleDriveLinkPreview(video.attach_video),
                                          style: {"width":"100%","border":"0","border-radius":"10px"}
                                        }, null, 8 /* PROPS */, _hoisted_112))
                                      : _createCommentVNode("v-if", true)
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (!video.video_url)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_113, _toDisplayString($setup.lms_website.__('Video url not found')), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        (video.link_type==='Attach File')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (!$options.isGoogleDriveLink(video.attach_video))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (video.attach_video)
                                      ? (_openBlock(), _createElementBlock("video", _hoisted_114, [
                                          _createElementVNode("source", {
                                            src: video.attach_video,
                                            type: "audio/ogg"
                                          }, null, 8 /* PROPS */, _hoisted_115),
                                          _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Your browser does not support the video tag.')), 1 /* TEXT */)
                                        ]))
                                      : _createCommentVNode("v-if", true)
                                  ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true),
                              ($options.isGoogleDriveLink(video.attach_video))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                                    (video.attach_video)
                                      ? (_openBlock(), _createElementBlock("iframe", {
                                          key: 0,
                                          class: "custom-iframe",
                                          src: $options.googleDriveLinkPreview(video.attach_video),
                                          style: {"width":"100%","border":"0","border-radius":"10px"}
                                        }, null, 8 /* PROPS */, _hoisted_117))
                                      : _createCommentVNode("v-if", true)
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (!video.attach_video)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_118, _toDisplayString($setup.lms_website.__('Video file url not found')), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ]))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 2 /* CLASS */),
                  ($data.lessonModal.lesson?.pdf_audio_list?.length || $data.lessonModal.lesson?.custom_text_content?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                        ($data.lessonModal.lesson?.pdf_audio_list?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                              _createElementVNode("div", _hoisted_121, _toDisplayString($setup.lms_website.__('Audio List')), 1 /* TEXT */),
                              _createElementVNode("ul", _hoisted_122, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.lessonModal.lesson?.pdf_audio_list, (audio) => {
                                  return (_openBlock(), _createElementBlock("li", _hoisted_123, [
                                    _createTextVNode(_toDisplayString(audio.title) + " ", 1 /* TEXT */),
                                    (audio.audio_file)
                                      ? (_openBlock(), _createElementBlock("audio", _hoisted_124, [
                                          _createElementVNode("source", {
                                            src: audio.audio_file,
                                            type: "audio/ogg"
                                          }, null, 8 /* PROPS */, _hoisted_125),
                                          _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Your browser does not support the audio tag.')), 1 /* TEXT */)
                                        ]))
                                      : _createCommentVNode("v-if", true)
                                  ]))
                                }), 256 /* UNKEYED_FRAGMENT */))
                              ])
                            ]))
                          : _createCommentVNode("v-if", true),
                        ($data.lessonModal.lesson?.custom_text_content?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                              _createElementVNode("div", _hoisted_127, _toDisplayString($setup.lms_website.__('Text Content')), 1 /* TEXT */),
                              _createElementVNode("div", {
                                class: "card-body",
                                innerHTML: $data.lessonModal.lesson?.custom_text_content
                              }, null, 8 /* PROPS */, _hoisted_128)
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode("/Video"),
            _createCommentVNode("Audio"),
            ($data.lessonModal.lesson?.custom_lesson_type==='Audio')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  ($data.lessonModal.lesson?.custom_video_type==='Audio Link' || $data.lessonModal.lesson?.custom_video_type==='Attach File')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        ($data.lessonModal.lesson?.custom_audio_link || $data.lessonModal.lesson?.custom_audio_file)
                          ? (_openBlock(), _createElementBlock("audio", _hoisted_129, [
                              _createElementVNode("source", {
                                src: $data.lessonModal.lesson?.custom_audio_link || $data.lessonModal.lesson?.custom_audio_file,
                                type: "audio/ogg"
                              }, null, 8 /* PROPS */, _hoisted_130),
                              _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Your browser does not support the audio tag.')), 1 /* TEXT */)
                            ]))
                          : _createCommentVNode("v-if", true),
                        (!$data.lessonModal.lesson?.custom_audio_link && !$data.lessonModal.lesson?.custom_audio_file)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_131, "Audio file url not found"))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode("/Audio"),
            _createCommentVNode("PDF"),
            ($data.lessonModal.lesson?.custom_lesson_type==='PDF')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  (!$options.isGoogleDriveLink($data.lessonModal.lesson?.custom_pdf_file))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["pdf-viewer", (!$data.lessonModal.file_loaded)?'is-loading':'']),
                        style: {"direction":"ltr"}
                      }, _hoisted_133, 2 /* CLASS */))
                    : _createCommentVNode("v-if", true),
                  ($options.isGoogleDriveLink($data.lessonModal.lesson?.custom_pdf_file))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                        ($data.lessonModal.lesson?.custom_pdf_file)
                          ? (_openBlock(), _createElementBlock("iframe", {
                              key: 0,
                              class: "custom-iframe",
                              src: $options.googleDriveLinkPreview($data.lessonModal.lesson?.custom_pdf_file),
                              style: {"width":"100%","border":"0","border-radius":"10px"}
                            }, null, 8 /* PROPS */, _hoisted_135))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (!$data.lessonModal.lesson?.custom_pdf_file)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_136, _toDisplayString($setup.lms_website.__('PDF file url not found')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (($data.lessonModal.lesson?.pdf_audio_list?.length || $data.lessonModal.lesson?.custom_text_content?.length))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                        ($data.lessonModal.lesson?.pdf_audio_list?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                              _createElementVNode("div", _hoisted_139, [
                                _createElementVNode("div", _hoisted_140, _toDisplayString($setup.lms_website.__('Audio List')), 1 /* TEXT */),
                                _createElementVNode("ul", _hoisted_141, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.lessonModal.lesson?.pdf_audio_list, (audio) => {
                                    return (_openBlock(), _createElementBlock("li", _hoisted_142, [
                                      _createTextVNode(_toDisplayString(audio.title) + " ", 1 /* TEXT */),
                                      (audio.audio_file)
                                        ? (_openBlock(), _createElementBlock("audio", _hoisted_143, [
                                            _createElementVNode("source", {
                                              src: audio.audio_file,
                                              type: "audio/ogg"
                                            }, null, 8 /* PROPS */, _hoisted_144),
                                            _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Your browser does not support the audio tag.')), 1 /* TEXT */)
                                          ]))
                                        : _createCommentVNode("v-if", true)
                                    ]))
                                  }), 256 /* UNKEYED_FRAGMENT */))
                                ])
                              ])
                            ]))
                          : _createCommentVNode("v-if", true),
                        ($data.lessonModal.lesson?.custom_text_content?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                              ($data.lessonModal.lesson?.custom_text_content?.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                                    _createElementVNode("div", _hoisted_147, _toDisplayString($setup.lms_website.__('Text Content')), 1 /* TEXT */),
                                    _createElementVNode("div", {
                                      class: "card-body",
                                      innerHTML: $data.lessonModal.lesson?.custom_text_content
                                    }, null, 8 /* PROPS */, _hoisted_148)
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode("/PDF"),
            _createCommentVNode("PDF Link"),
            ($data.lessonModal.lesson?.custom_lesson_type==='PDF Link')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _createElementVNode("div", _hoisted_149, [
                    ($data.lessonModal.lesson?.custom_pdf_link)
                      ? (_openBlock(), _createElementBlock("iframe", {
                          key: 0,
                          class: "custom-iframe",
                          src: $data.lessonModal.lesson?.custom_pdf_link,
                          style: {"width":"100%","border":"0","border-radius":"10px"}
                        }, null, 8 /* PROPS */, _hoisted_150))
                      : _createCommentVNode("v-if", true)
                  ]),
                  ($data.lessonModal.lesson?.custom_text_content?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                        _createElementVNode("div", _hoisted_152, _toDisplayString($setup.lms_website.__('Text Content')), 1 /* TEXT */),
                        _createElementVNode("div", {
                          class: "card-body",
                          innerHTML: $data.lessonModal.lesson?.custom_text_content
                        }, null, 8 /* PROPS */, _hoisted_153)
                      ]))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode("/PDF Link")
          ])
        ])
      ], 2 /* CLASS */)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}